module.exports = __webpack_public_path__ + "img/ico-check-de1.9b41d70d.svg";